// Initialize Global Klaviyo Listener only ONCE
if (!window.bdKlaviyoFormInitialized) {
  window.bdKlaviyoFormInitialized = true;

  document.addEventListener('submit', async function(e) {
    const form = e.target.closest('[data-klaviyo-form]');
    if (!form) return; // Ignore forms that don't have the attribute

    e.preventDefault();
    
    // Find the wrapper and messages relative to the form
    const wrapper = form.closest('[data-klaviyo-wrapper]') || form.parentElement;
    const successMsg = wrapper.querySelector('[data-klaviyo-success]');
    const errorMsg = wrapper.querySelector('[data-klaviyo-error]');
    const source = form.dataset.source || 'Shopify Custom Form';
    
    if (errorMsg) errorMsg.style.display = 'none';

    // Get API keys from the form's data attributes
    const publicKey = form.dataset.klaviyoPublicKey;
    const listId = form.dataset.klaviyoListId;

    if (!publicKey || !listId) {
      if (errorMsg) {
        errorMsg.querySelector('.email-signup__message-text').textContent = "Newsletter configuration is missing.";
        errorMsg.style.display = 'flex';
      }
      return;
    }

    // Gather all inputs dynamically
    const inputs = form.querySelectorAll('input, select, textarea');
    let email = '';
    const properties = {}; // Will hold custom fields like first_name, Birthday, etc.
    
    inputs.forEach(input => {
      // Ignore honeypot fields
      if (input.name === 'source') return; 
      
      if (input.type === 'email' || input.name === 'email') {
        email = input.value;
      } else if (input.name) {
        properties[input.name] = input.value;
      }
    });

    const button = form.querySelector('button[type="submit"], button');
    const originalText = button ? button.textContent : '';
    if (button) {
      button.textContent = 'Submitting...';
      button.disabled = true;
    }

    // FIXED: Using the exact JSON:API nested structure from your working script
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: properties
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    console.log('Sending Klaviyo Payload:', payload);

    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${publicKey}`, {
        method: 'POST',
        headers: {
          // CRITICAL: Klaviyo V3 JSON:API requires this specific content type
          'Content-Type': 'application/vnd.api+json',
          'Accept': 'application/vnd.api+json',
          'revision': '2024-10-15' // The stable revision from your working script
        },
        body: JSON.stringify(payload)
      });

      console.log('Klaviyo Response Status:', response.status);

      if (response.ok || response.status === 202) {
        form.style.display = 'none';
        if (successMsg) successMsg.style.display = 'flex';
      } else {
        const errorData = await response.json();
        console.error('Klaviyo API Error Details:', errorData);
        throw new Error(errorData.errors?.[0]?.detail || 'Subscription failed');
      }
    } catch (error) {
      if (button) {
        button.textContent = originalText;
        button.disabled = false;
      }
      if (errorMsg) {
        errorMsg.style.display = 'flex';
        console.error('Klaviyo Catch Error:', error);
      }
    }
  });
}